import React from 'react';

const faqs = [
    {
        q: "Potřebuji doporučení od lékaře?",
        a: "Ne, doporučení od lékaře nepotřebujete. Můžete se objednat přímo přes online rezervaci nebo telefonicky.",
    },
    {
        q: "Co si mám obléknout a vzít s sebou?",
        a: "Doporučuji pohodlné sportovní oblečení, ve kterém se cítíte volně. S sebou si můžete přinést případnou zdravotní dokumentaci, snímky (RTG, MR, CT) nebo zprávy od lékařů, pokud máte.",
    },
    {
        q: "Jak dlouho trvá jedno sezení?",
        a: "Vstupní kineziologický rozbor trvá 60 minut, abych měl čas důkladně zjistit váš problém. Následné terapie trvají 45–55 minut podle zvolené služby.",
    },
    {
        q: "Přijímáte zdravotní pojišťovny?",
        a: "Nemám uzavřené smlouvy se zdravotními pojišťovnami. Péče je hrazena přímo klientem dle ceníku.",
    },
    {
        q: "Můžu platit kartou?",
        a: "Bohužel zatím nepřijímám platební karty. Platba probíhá v hotovosti nebo přes QR kód (okamžitý převod na účet) přímo v ambulanci.",
    },
    {
        q: "Jak zrušit nebo přesunout rezervaci?",
        a: "Rezervaci můžete zdarma zrušit nebo přesunout nejpozději 24 hodin před termínem přes svůj rezervační profil nebo telefonicky.",
    },
    {
        q: "Co je DNS a komu pomáhá?",
        a: "DNS (Dynamická neuromuskulární stabilizace) je moderní rehabilitační koncept vyvinutý v České republice. Vychází z principů vývojové kineziologie a pomáhá obnovit správný pohybový vzor — využívám ji u sportovců i u běžných potíží pohybového aparátu.",
    },
];

const FaqSection = () => {
    return (
        <div>
            <div className="text-center mb-12">
                <span className="badge-brand mb-3">Časté dotazy</span>
                <h3 className="text-3xl md:text-4xl font-bold text-ink-900">Na co se klienti ptají</h3>
                <div className="mt-4 flex justify-center"><span className="accent-bar" /></div>
            </div>

            <div className="max-w-3xl mx-auto space-y-3">
                {faqs.map((item) => (
                    <details
                        key={item.q}
                        className="group card p-0 overflow-hidden transition-shadow hover:shadow-soft-lg"
                    >
                        <summary className="flex items-center justify-between gap-4 cursor-pointer list-none px-6 py-5">
                            <h4 className="text-base md:text-lg font-semibold text-ink-900">{item.q}</h4>
                            <span className="w-8 h-8 rounded-full bg-brand-50 text-brand-600 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ease-smooth group-open:rotate-180">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </span>
                        </summary>
                        <div className="px-6 pb-6 -mt-1 text-ink-600 leading-relaxed">
                            {item.a}
                        </div>
                    </details>
                ))}
            </div>
        </div>
    );
};

export { faqs };
export default FaqSection;
